<section *rxLet="state$ as state" class="personal-details" data-test-id="user-profile-personal-details-container">
  <h4 class="font-bold">Personal details</h4>
  @if (!state.personalDetailsLoading) {
    @if (state.personalDetails) {
      <personal-details-email-update
        [email]="state.personalDetails?.Email"
        data-test-id="user-profile-emailAddressEdit"
      ></personal-details-email-update>
      <phones-edit
        [canEdit]="state.canEdit"
        [phones]="state.personalDetails?.Phones"
        (serverError)="onServerError()"
        (updateSuccess)="personalDetailsPhonesUpdated($event)"
        data-test-id="user-profile-phonesEdit-container"
        updateMethodName="updatePhonesProfile"
      ></phones-edit>
      <address-edit
        [address]="state.personalDetails?.Address"
        [canEdit]="state.canEdit"
        (serverError)="onServerError()"
        (updateSuccess)="personalDetailsAddressUpdated($event)"
        data-test-id="user-profile-addressEdit-container"
        updateMethodName="updateAddressProfile"
      ></address-edit>
    } @else {
      <no-data></no-data>
    }
  } @else {
    <div class="flex flex-center-start w-full h-full">
      <loader color="primary"></loader>
    </div>
  }
  @if (!state.consultantsTenantDetailsLoading) {
    <div class="alias-box" data-test-id="user-profile-personal-details-alias-box">
      <div class="alias-label">Darize Alias</div>
      @if (state.consultantsTenantDetails?.ConsultantUPN) {
        <div class="alias-value">{{ state.consultantsTenantDetails.ConsultantUPN }}</div>
      }
      @if (!state.consultantsTenantDetails?.ConsultantUPN) {
        <div class="alias-value">
          Not registered
          <tooltip-popover #tooltip2 data-test-id="not-registered-tooltipPopover" position="bottom">
            <mat-icon-with-hover
              #tooltipIcon
              iconName="tooltip_default"
              iconNameActive="tooltip_active"
              iconNameHover="tooltip_hover"
            ></mat-icon-with-hover>
            <ng-template #tooltipPopoverContent="cdkPortal" cdkPortal let-tooltipPopover>
              <div class="tooltip-content">If you are Darize Consultant, please contact support&#64;darize.com</div>
            </ng-template>
          </tooltip-popover>
        </div>
      }
    </div>
  } @else {
    <div class="flex flex-center-start w-full h-full">
      <loader color="primary"></loader>
    </div>
  }
</section>
